export default __webpack_public_path__ + "static/media/truck-1030846_640.41ba808d.jpg";